import React from 'react';
import Toast from './Toast';

const ToastContainer = ({ toasts, onCloseToast }) => {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 pointer-events-none">
      {toasts.map((toast, index) => (
        <div 
          key={toast.id} 
          className="pointer-events-auto"
          style={{ 
            transform: `translateY(${index * 8}px)`,
            zIndex: 50 - index 
          }}
        >
          <Toast
            type={toast.type}
            message={toast.message}
            isVisible={toast.isVisible}
            onClose={() => onCloseToast(toast.id)}
            duration={0} // Let the hook manage duration
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer; 